// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#data-import-template-dlg .modal-dialog {\n        max-width: 50vw;\n    }\n        #data-import-template-dlg .modal-dialog .modal-body a {\n                color: #59ace3;\n            }\n        #data-import-template-dlg .modal-dialog .modal-footer button {\n                margin: 0 auto;\n            }\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
